import React from 'react';
import MenuItems from "./MenuItems";
import {withRouter} from "../../utils/withRouter";
import { Link } from "react-router-dom";
class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            selected: null,
        }
    }
    componentDidMount() {
        let listPermission = JSON.parse(localStorage.getItem("sas_school_per"))
        if (listPermission !== null && listPermission !== undefined){
            let allMenuItems = MenuItems.AdminSchool
            for (let i=0; i< allMenuItems.length; i++){
                let item = allMenuItems[i]
                let permissionArr = item.permission.split("|")
                let isShow = false;
                for (let i1=0; i1< permissionArr.length; i1++){
                    isShow = listPermission.includes(permissionArr[i1])
                    if (isShow){
                        break
                    }
                }
                item.isShow = isShow
                let children = item.children
                for (let y=0; y< children?.length; y++){
                    let permissionArr = children[y].permission.split("|")
                    let isShow = false;
                    for (let y1=0; y1< permissionArr.length; y1++){
                        isShow = listPermission.includes(permissionArr[y1])
                        if (isShow){
                            break
                        }

                    }
                    children[y].isShow = isShow
                }
            }
            this.setState({items: allMenuItems})
        }
    }

    render() {
        let activeClass = this.props?.activeClass;
        let parentClass = this.props?.parentClass;
        let selected = this.state.selected;
        return (
            <div className="col-md-2 card border-color mb-3 p-0" style={{height: '100%'}}>
                {/*<div className="col-md-3">*/}
                <ul className="menu-y text-sm nav nav-tabs sidebar overflow-hidden">
                    {this.state.items?.map((item, index) => (
                        item.isShow && <li style={{backgroundColor: "#fff"}}>
                            <Link to={item.url ? item.url : "#"} data-toggle="collapse"
                                  data-target={`#${item.activeClass}`}
                                  onClick={() => {
                                      if (selected === item.activeClass) {
                                          this.setState({selected: null})
                                      } else {
                                          this.setState({selected: item.activeClass})
                                      }
                                  }}
                                  className={`${activeClass === item.activeClass ? 'active' : ''} d-block py-2 no-border-top d-flex justify-content-between align-items-center`}>
                                <span style={{minHeight: 30, lineHeight: '30px'}}>
                                    <i className={item.icon} aria-hidden="true"/>
                                    {item.title}
                                </span>
                                {item?.children?.length > 0 &&
                                <i className={`${(item.activeClass === parentClass || item.activeClass === selected) ? 'fas fa-angle-down' : 'fas fa-angle-right'} icon-arrow-side-bar`}/>}
                            </Link>
                            {item?.children?.length > 0 && <ul id={item.activeClass}
                                                               className={`${(item.activeClass === parentClass || item.activeClass == selected) ? 'content-side-bar-active' : 'content-side-bar'} submenu-y collapse`}>
                                {item?.children?.length > 0 && item?.children?.map((_item, idx) => (
                                    _item.isShow && <li style={{backgroundColor: "#fff"}}>
                                        <Link to={_item.url}
                                              onClick={() => {
                                                  this.setState({selected: _item.parentClass})
                                              }}
                                              className={`${activeClass === _item.activeClass ? 'active' : ''} d-block py-2`}>
                                            <span style={{overflow: 'hidden',  display: '-webkit-box', '-webkit-line-clamp': '2', '-webkit-box-orient': 'vertical'}}>
                                                <i className="caret"/>
                                                {_item.title}
                                            </span>
                                        </Link>
                                    </li>
                                ))}
                            </ul>}
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}

export default withRouter(Sidebar)
